module.exports = __webpack_public_path__ + "static/media/tutorial-03.ce786b42.jpg";